import * as moment from "moment/moment";

// Interfaz para el resultado general del schedule
export interface IResultSchedule {
  count: number;
  next: string | null;
  previous: string | null;
  results: ISchedule[];
}

// Clase para el resultado general del schedule
export class ResultSchedule {
  count: number;
  next: string | null;
  previous: string | null;
  results: Schedule[];

  constructor(result?: IResultSchedule) {
    if (result) {
      this.count = result.count;
      this.next = result.next;
      this.previous = result.previous;
      this.results = result.results ? Schedule.fromObjectArray(result.results) : [];
    } else {
      this.count = 0;
      this.next = null;
      this.previous = null;
      this.results = [];
    }
  }

  static fromObject(result: IResultSchedule): ResultSchedule {
    return new ResultSchedule(result);
  }
}

// Interfaz para cada schedule
export interface ISchedule {
  id?: number;
  member_name: string;
  day: string;
  gic: number;
  ra: number;
  dob: string;
  provider: number;
  fullName:string;
  patient_id: number;
  provider_name: string | null;
  practice_din: string;
  appointment_npi: string;
  billing_tin: string;
  status: string;
  visited: boolean;
  cancelable:string|null;
  unread: boolean;
  treated_provider_name: string | null;
  created?: moment.Moment | null;
  modified?: moment.Moment | null;
  birthDate?: moment.Moment | null;
}

// Clase para cada schedule
export class Schedule {
  id?: number;
  memberName: string;
  fullName:string;
  day: moment.Moment;
  gic: number;
  ra: number;
  dob: moment.Moment|null;
  provider: number;
  patientId: number;
  providerName: string | null;
  practiceDin: string;
  appointmentNpi: string;
  billingTin: string;
  status: string;
  visited: boolean;
  cancelable:boolean;
  unread: boolean;
  treatedProviderName: string | null;
  created?: moment.Moment | null;
  birthDate?: moment.Moment | null;
  modified?: moment.Moment | null;

  constructor(ent?: ISchedule) {
    if (ent) {
      this.id = ent.id;
      this.memberName = ent.member_name;
      this.day = moment(ent.day);
      this.gic = ent.gic;
      this.ra = ent.ra;
      this.dob = moment(ent.dob);
      this.provider = ent.provider;
      this.patientId = ent.patient_id;
      this.providerName = ent.provider_name;
      this.practiceDin = ent.practice_din;
      this.appointmentNpi = ent.appointment_npi;
      this.billingTin = ent.billing_tin;
      this.status = ent.status;
      this.fullName=ent.fullName;
      this.visited = ent.visited;
      this.unread = ent.unread;
      this.cancelable = ent.cancelable === 'Y';
      this.treatedProviderName = ent.treated_provider_name;
      this.created = ent.created ? moment(ent.created) : null;
      this.modified = ent.modified ? moment(ent.modified) : null;
      this.birthDate = ent.birthDate ?moment(ent.birthDate) : null;
    }
  }

  static fromObject(ent: ISchedule): Schedule {
    return new Schedule(ent);
  }

  static fromObjectArray(ent: ISchedule[]): Schedule[] {
    return ent.map(item => new Schedule(item));
  }
}
